@if ((userName$ | async) && (generateNavigationLinks$ | async)) {
  <ng-content></ng-content>
}
<!-- The  notification$ input will be removed -->
<!-- Refactor supportedLanguages input -->
<lib-common-mat-navbar
  class="app-navbar-container"
  [displaySlideToggleTheme]="enableThemeSwitcher$ | async"
  [initialTheme]="navbarTheme"
  [logotypeClass]="logoTypeThemeClass"
  [isAuthenticated]="(authService.isAuthenticated$ | async)!"
  [organizations]="(accessibleTenants$ | async)!"
  [currentOrganizationLogo]="(getCurrentTenantLogo$ | async)!"
  [showOrganizationSwitcher]="showNoLastAccessedTenantModal$ | async"
  [accountMenu]="getAccountMenuData$ | async"
  [unreadNotificationsCount]="(getUnreadNotificationsCount$ | async)!"
  [totalNotificationsCount]="getTotalNotificationsCount$ | async"
  [notificationsInProgress$]="notificationsInProgress$"
  [refreshGrid$]="refreshNotifications$"
  [notifications]="(getNotifications$ | async)!"
  [notificationService$]="notificationService$"
  [displayOnlyLogo]="(currentCustomProvisioningData$ | async) !== undefined"
  [enableUserActionsSideNav]="true"
  [enableNotificationsSideNav]="true"
  [enableHelpSideNav]="true"
  [enableOrganizationSwitcher]="false"
  [helpItems]="helpItems"
  [techSupportURL]="(techSupportURL$ | async)!"
  [navItems]="navItems"
  [bannerItems]="bannerItems"
  [homeMenuTitle]="homeMenuTitle"
  [supportedLanguages]="supportedLanguages"
  [displayLanguageToggle]="displayLanguageToggle$ | async"
  [selectedLang]="selectedLang"
  [helpMenuToOpen]="(helpMenuToOpen$ | async)!"
  (helpItemClick)="helpItemClicked($event)"
  (menuItemClick)="menuItemClicked($event)"
  (logoutClick)="logoutClicked()"
  (goToHomeClick)="goToHome()"
  (raLogoClick)="onRaLogoClick()"
  (bannerButtonClick)="bannerButtonClicked($event)"
  (bannerCloseButtonClick)="hideBanner($event)"
  (notificationAction)="notificationAction($event)"
  (currentTheme)="setLogoTheme($event)"
  (langItemClick)="setSelectedLang($event)"
  (joinOrgClicked)="joinOrgClicked($event)"
  (manageOrganizationsAction)="manageOrganizationsAction()"
  (notificationCustomActionClick)="notificationCustomActionClicked($event)"
>
  @if (authService.isAuthenticated$ | async) {
    @if (languageChanged$ | async) {}
    @if (maintenanceWindow$ | async) {}
    @if (maintenanceWindowCompleted$ | async) {}
    @if (updateOrganizations$ | async) {}
    @if (signalRConnected$ | async) {}
    @if (signalRNotifyProgress$ | async) {}
    @if (signalRUserNotifications$ | async) {}
    @if (notificationAction$ | async) {}
    @if (refreshNotificationsGrid$ | async) {}
    @if (getMarkingAllAsRead$ | async) {}
    @if (helpMenuToOpen$ | async) {}
    @if (sessionTimedOut$ | async) {}
    @if (click$ | async) {}
    @if (countDownTimer$ | async) {}
  }
  @if (onEulaAccepted$ | async) {
    @if (getUserNotificationCounts$ | async) {}
    @if (getUserNotifications$ | async) {}
  }

  <div class="main-container">
    <div class="navigation-container">
      @if (shouldShowBreadcrumb) {
        <app-navigation></app-navigation>
      }
      <div class="signalr-status-icon">
        <app-signalr-status></app-signalr-status>
      </div>
    </div>

    <router-outlet></router-outlet>
  </div>
</lib-common-mat-navbar>
@if (queryParams$ | async) {}
@if (routeSnapshot$ | async) {}
@if (selectedTenant$ | async) {}
@if (signalRConnectionState$ | async) {}
